/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GameIconEntry
 */
export interface GameIconEntry {
    /**
     * 
     * @type {string}
     * @memberof GameIconEntry
     */
    name: string;
    /**
     * 1:1 square icon for icon slots (rail, chips, header). Absent → render a monogram fallback.
     * @type {string}
     * @memberof GameIconEntry
     */
    iconUrl?: string;
    /**
     * 3:4 platform poster for cards, hero backgrounds, and search thumbnails only. Never use in an icon slot.
     * @type {string}
     * @memberof GameIconEntry
     */
    boxArtUrl?: string;
}

/**
 * Check if a given object implements the GameIconEntry interface.
 */
export function instanceOfGameIconEntry(value: object): value is GameIconEntry {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GameIconEntryFromJSON(json: any): GameIconEntry {
    return GameIconEntryFromJSONTyped(json, false);
}

export function GameIconEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameIconEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'iconUrl': json['iconUrl'] == null ? undefined : json['iconUrl'],
        'boxArtUrl': json['boxArtUrl'] == null ? undefined : json['boxArtUrl'],
    };
}

export function GameIconEntryToJSON(json: any): GameIconEntry {
    return GameIconEntryToJSONTyped(json, false);
}

export function GameIconEntryToJSONTyped(value?: GameIconEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'iconUrl': value['iconUrl'],
        'boxArtUrl': value['boxArtUrl'],
    };
}

